import { render, staticRenderFns } from "./PanelItemTip.vue?vue&type=template&id=49ca1bcc&scoped=true&"
import script from "./PanelItemTip.vue?vue&type=script&lang=js&"
export * from "./PanelItemTip.vue?vue&type=script&lang=js&"
import style0 from "./PanelItemTip.vue?vue&type=style&index=0&id=49ca1bcc&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49ca1bcc",
  null
  
)

export default component.exports